import { raTourLanguageFrench } from '@react-admin/ra-tour';
import { merge } from 'lodash';
import coreTranslationMessages from 'ra-language-french';

import commonTranslationsFr from '@Common/i18n/locales/fr_FR.json';

import { frTranslationsBoCommon } from '@sh4res/bo-common/i18n/fr';
import { b2bAdminsTranslations } from '@sh4res/bo-common/i18n/fr/b2b/admins';
import { b2bContractFeeChargesTranslations } from '@sh4res/bo-common/i18n/fr/b2b/contract_fee_charges';
import { b2bContractsTranslations as b2bContractsTranslationsCommon } from '@sh4res/bo-common/i18n/fr/b2b/contracts';
import { b2bIndividualOperationsTranslations } from '@sh4res/bo-common/i18n/fr/b2b/individual_operations';
import { b2bInvestorProfileTranslations } from '@sh4res/bo-common/i18n/fr/b2b/investor_profile';
import { b2bRecurringInvestmentsTranslations } from '@sh4res/bo-common/i18n/fr/b2b/recurring_investments';
import { b2bWithdrawalsTranslations } from '@sh4res/bo-common/i18n/fr/b2b/withdrawals';
import { instrumentsTranslations as instrumentsTranslationsCommon } from '@sh4res/bo-common/i18n/fr/instruments';
import { taskStateTranslations } from '@sh4res/bo-common/i18n/fr/tasks';
import { filterKeysByPrefix } from '@sh4res/bo-common/utils/filter_keys_by_prefix';

import { enTranslations } from '@I18n/en';
import { adminSelectorTranslations } from '@I18n/fr/admin_selector';
import { appBarTranslations } from '@I18n/fr/app_bar';
import { campaignsTranslations } from '@I18n/fr/campaigns';
import { collectiveOperationsTranslations } from '@I18n/fr/collective_operations';
import { companiesTranslations } from '@I18n/fr/companies';
import { companiesDocumentsTranslations } from '@I18n/fr/companies/documents';
import { contactSupportPageTranslations } from '@I18n/fr/contact_support_page';
import { distributorTranslations } from '@I18n/fr/distributor';
import { documentsTranslations } from '@I18n/fr/documents';
import { employeesTranslations } from '@I18n/fr/employees';
import { identityTranslations } from '@I18n/fr/identity';
import { loginPageTranslations } from '@I18n/fr/login_page';
import { maintenancePageTranslations } from '@I18n/fr/maintenance_page';
import { ordersTranslations } from '@I18n/fr/orders';
import { fullyManagedPlanContributionsTranslations } from '@I18n/fr/orders/fully_managed_plan_contributions';
import { savingsFundsRequestsTranslations } from '@I18n/fr/savings_funds_requests';
import { toursTranslations } from '@I18n/fr/tours';

const translations = {
  ...coreTranslationMessages,
  ...raTourLanguageFrench,
  ...filterKeysByPrefix(commonTranslationsFr, 'common.'),
  login_page: loginPageTranslations,
  maintenance_page: maintenancePageTranslations,
  app_bar: appBarTranslations,
  contact_support_page: contactSupportPageTranslations,
  'ra-preferences': {
    action: {
      choose_columns: 'Choisir les colonnes',
    },
  },
  'ra.validation.required': 'Erreur: ce champ est obligatoire',
  'ra.validation.required.short': 'Requis',
  'ra.validation.email': 'Erreur: l’adresse e-mail doit être valide',
  'ra.notification.application_update_available': 'Nouvelle version disponible',
  'ra.action.update_application': 'Rafraîchir',
  menu: {
    services: 'Services',
    employees: 'Salariés',
    dashboard: 'Tableau de bord',
    company: 'Entreprise',
    companies: 'Entreprises',
    contracts: 'Contrats',
    withdrawals: 'Retraits',
    fully_managed_plan_contributions: 'Abondements',
    payouts: 'Paiements',
    campaigns: 'Campagnes',
    savings_funds_requests: 'Opérations',
    operations: 'Opérations',
    collective_operations: 'Opérations',
    operations_er: 'Contributions obligatoires',
    distributor: 'Apporteur',
    contract_fee_charges: 'Frais',
    instruments: 'Liste des fonds',
    admins: 'Correspondants',
    orders: 'Ordres',
    planned_operations: 'Opérations planifiées',
    recurring_voluntary_deposits: 'Versements volontaires récurrents',
    individual_operations: 'Opérations individuelles',
    documents: 'Documents',
  },

  footer: {
    brand: '@%{year} AXA tous droits réservés',
    links_href: {
      accessibility: 'https://www.axa-mon-epargne-entreprises.com/declarations-accessibilite',
      data_protection:
        'https://axa-vitrine.wixstudio.com/vitrine-phenix/gestion-des-donn%C3%A9es-personnelles',
      cookie: 'https://axa-vitrine.wixstudio.com/vitrine-phenix/politique-des-cookies',
      sitemap: 'https://axa-vitrine.wixstudio.com/vitrine-phenix/plan-du-site',
      legal_information: 'https://axa-vitrine.wixstudio.com/vitrine-phenix/mentions-legales',
      contact_us: '/#/contact_support',
    },
    links_label: {
      accessibility: 'Accessibilité : Conformité',
      data_protection: 'Protection des données',
      cookie: 'Politique de cookies',
      sitemap: 'Plan du site',
      legal_information: 'Informations légales',
      contact_us: 'Contactez-nous',
    },
    social_media_links: {
      x: 'https://x.com',
      facebook: 'https://facebook.com',
      youtube: 'https://youtube.com',
      instagram: 'https://instagram.com',
    },
  },

  tours: toursTranslations,

  profile_popup: {
    logout: 'Déconnectez-vous',
    contact_support: 'Assistance',
  },

  general: {
    sections: {
      details: 'Détails',
    },
    upload: {
      dropzone: 'Déposez un fichier ou sélectionnez-le',
    },
  },

  resources: {
    ...frTranslationsBoCommon,
    ...campaignsTranslations,
    ...collectiveOperationsTranslations,
    ...instrumentsTranslationsCommon,
    investor_profile: b2bInvestorProfileTranslations,
    companies: companiesTranslations,
    identity: identityTranslations,
    employees: employeesTranslations,
    admins: b2bAdminsTranslations,
    documents: documentsTranslations,
    orders: ordersTranslations,
    savings_funds_requests: savingsFundsRequestsTranslations,
    contracts: b2bContractsTranslationsCommon,
    'orders/fully_managed_plan_contributions': fullyManagedPlanContributionsTranslations,
    distributor: distributorTranslations,
    'companies/documents': companiesDocumentsTranslations,
    contract_fee_charges: b2bContractFeeChargesTranslations,
    individual_operations: b2bIndividualOperationsTranslations,
    recurring_investments: b2bRecurringInvestmentsTranslations,
    'recurring_investments/allocations': b2bRecurringInvestmentsTranslations.allocations,
    admin_selector: adminSelectorTranslations,
    tasks: { states: taskStateTranslations },
    withdrawals: b2bWithdrawalsTranslations,
  },
} satisfies typeof enTranslations;

export const frTranslations = merge({}, enTranslations, translations);
